"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Fan(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M12 2c5.511 0 10 4.489 10 10s-4.489 10-10 10S2 17.511 2 12 6.489 2 12 2zm6.834 7.016c-1.705-.021-3.195.45-4.314 1.379.3.466.48 1.015.48 1.605 0 .95-.46 1.792-1.158 2.344.328 1.948-.1 3.87-1.217 5.625A7.978 7.978 0 0 0 20 12a8.001 8.001 0 0 0-.564-2.95c-.203-.015-.405-.032-.602-.034zM4.994 8.13A7.98 7.98 0 0 0 4 12a7.983 7.983 0 0 0 6.334 7.824l-.043-.035c1.344-1.598 1.853-3.123 1.643-4.795-1.528-.035-2.777-1.235-2.909-2.738-1.81-.8-3.179-2.222-4.03-4.125zM12 11c-.564 0-1 .436-1 1 0 .564.436 1 1 1 .564 0 1-.436 1-1 0-.564-.436-1-1-1zm0-7a7.975 7.975 0 0 0-5.637 2.314l.067-.02c.597 2.003 1.594 3.264 3.11 4.005A3.005 3.005 0 0 1 12 9c.321 0 .625.065.916.16 1.43-1.336 3.32-2.027 5.361-2.119A7.972 7.972 0 0 0 12 4z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Fan;
